import $ from 'jquery';
import '../sass/style.scss';
import slick from 'slick-carousel';
import fitty from 'fitty';
import unveil from 'unveil2';

import React from 'react';
import ReactDOM from 'react-dom';
import FilterList from './Filter';

const $title = $('.section-intro').find('h2');
if ($title.length > 0) {
  $('.section-intro').append(
    `<div class="background-text">${$title.text()}</div>`
  );
  fitty('.background-text');
}

$('img').unveil();

ReactDOM.render(<FilterList />, document.getElementById('formftp'));



// WEBPACK FOOTER //
// ./js/app.js